const o = {
  name: "Spain",
  dimensions: { width: 22, height: 23 },
  content: `
    <g>
      <path d="M11 21.8375C16.5228 21.8375 21 17.3604 21 11.8375C21 6.31468 16.5228 1.83752 11 1.83752C5.47715 1.83752 1 6.31468 1 11.8375C1 17.3604 5.47715 21.8375 11 21.8375Z" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11 4.83752V6.83752L13 5.83752" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9 5.83752L11 6.83752L9 7.83752" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11 6.83752L13 7.83752" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M16 6.93713C17.2 8.23713 18 9.93713 18 11.8371" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
  `
};
export {
  o as Spain
};
